export default [
  { title: "Require ID verification", icon: "", link: "/docs/require-id" },
  { title: "Require knowledge-based authentication", icon: "", link: "/docs/require-knowledge" },
  { title: "Require phone authentication", icon: "", link: "/docs/require-phone" },
  { title: "Require access code authentication", icon: "", link: "/docs/require-access" },
];
